import type { StaffRole } from "@/shared/api/types";
import { paths } from "@/shared/lib/paths";
import type { IconName } from "@/shared/ui";

/** Live counters a sidebar item can show (AppLayout loads them). */
export type NavBadge = "pendingEssays";

export interface NavItem { to: string; label: string; icon: IconName; end?: boolean; roles?: StaffRole[]; badge?: NavBadge }
export interface NavSection { title?: string; items: NavItem[] }

/** Sidebar menu. `roles` hides an item from staff without access. */
export const NAVIGATION: NavSection[] = [
  { items: [{ to: paths.dashboard, label: "Tổng quan", icon: "dashboard", end: true }] },
  {
    title: "Nội dung",
    items: [
      { to: paths.courses, label: "Khóa học & giáo án", icon: "book" },
      { to: paths.courseImports, label: "Tạo khóa học từ tài liệu", icon: "upload" },
      { to: paths.vocabulary, label: "Từ vựng", icon: "library" },
      { to: paths.hanviet, label: "Hán Việt", icon: "textCursor" },
      { to: paths.readings, label: "Bài đọc", icon: "fileText" },
      { to: paths.promos, label: "Banner quảng cáo", icon: "image" },
      { to: paths.languages, label: "Ngôn ngữ & cấp độ", icon: "languages" },
      { to: paths.essays, label: "Chấm bài luận", icon: "clipboardCheck", badge: "pendingEssays" },
      { to: paths.aiRoleplays, label: "Hội thoại AI", icon: "messageSquare" }, // AI group E (speaking)
    ],
  },
  {
    title: "Học viên",
    items: [
      { to: paths.results, label: "Kết quả học tập", icon: "chart" },
      { to: paths.pronunciation, label: "Phát âm khó", icon: "mic" },
      { to: paths.users, label: "Tài khoản", icon: "users", roles: ["admin"] },
      { to: paths.classrooms, label: "Lớp học", icon: "graduation", roles: ["admin"] },
      { to: paths.orgs, label: "Trung tâm (B2B)", icon: "users", roles: ["admin"] },
      { to: paths.center, label: "Bảng điều khiển trung tâm", icon: "chart", roles: ["admin"] },
      { to: paths.friendReports, label: "Báo cáo người dùng", icon: "alert", roles: ["admin"] },
      { to: paths.billing, label: "Gói Premium", icon: "crown", roles: ["admin"] },
      { to: paths.notifications, label: "Thông báo", icon: "bell", roles: ["admin"] },
      { to: paths.feedback, label: "Góp ý", icon: "messageSquare", roles: ["admin"] },
      { to: paths.analytics, label: "Phân tích hành vi", icon: "activity", roles: ["admin"] },
      { to: paths.leagues, label: "Giải đấu", icon: "trendingUp", roles: ["admin"] }, // leagues & quests
      { to: paths.questTemplates, label: "Mẫu nhiệm vụ tuần", icon: "target", roles: ["admin"] },
    ],
  },
  {
    title: "AI",
    items: [
      { to: paths.ai, label: "Cài đặt AI", icon: "sparkles", end: true, roles: ["admin"] },
      { to: paths.aiProviders, label: "Nhà cung cấp & API key", icon: "lock", roles: ["admin"] },
      { to: paths.aiFeatures, label: "Tính năng AI", icon: "zap", roles: ["admin"] },
      { to: paths.aiUsage, label: "Sử dụng & chi phí", icon: "activity", roles: ["admin"] },
      { to: paths.aiVoice, label: "Giọng nói", icon: "mic", roles: ["admin"] }, // ai-voice-reader
    ],
  },
  {
    title: "Quản trị",
    items: [
      { to: paths.staff, label: "Nhân sự", icon: "shield", roles: ["admin"] },
      { to: paths.orgPricing, label: "Bảng giá trung tâm", icon: "crown", roles: ["admin"] },
      { to: paths.audit, label: "Nhật ký", icon: "clock", roles: ["admin"] },
    ],
  },
];

/** A center admin's whole menu: their centers' dashboard (docs/b2b-centers-contract.md OC-8). */
export const CENTER_NAVIGATION: NavSection[] = [
  { items: [{ to: paths.center, label: "Trung tâm của tôi", icon: "graduation" }] },
];
